import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const useNotificationsStore = defineCollectionStore({
    id: 'notifications',
    endpoint: '/api/notifications',
    dataKey: 'notificationsData',
    errorLabel: 'Fetch Notifications Error: ',
    fetchName: 'fetchNotifications',
    extraState: () => ({
        notificationsData: null,
        readNotificationIDs: [],
    }),
    getters: {
        getNotificationsData(state: any) {
            if (state.notificationsData !== null) {
                return state.notificationsData;
            }
        },
        getUnreadCount(state: any) {
            const { notificationsData, readNotificationIDs } = state;
            if (notificationsData !== null) {
                if (readNotificationIDs !== null && !readNotificationIDs.length) return notificationsData.length;
                const ids = new Set(readNotificationIDs);
                const count = notificationsData.reduce((acc: number, obj: any) => {
                    if (!ids.has(obj.id)) return acc + 1;
                    return acc;
                }, 0);
                return count;
            }
            return 0;
        },
    },
    extraActions: {
        async fetchNotifications(this: any) {
            try {
                // New envelope: `res.data` is already the flat array of records (no `.records` unwrap needed).
                const res: any = await $fetch('/api/notifications');
                this.notificationsData = res?.data ? res.data : [];
                this.version = res?.meta?.version ?? null;
            } catch (e) {
                console.log('Fetch Notifications Error: ', e);
            }
            const readNotificationIDs = localStorage.getItem('readNotificationIDs');
            this.readNotificationIDs = readNotificationIDs ? JSON.parse(readNotificationIDs) : [];
        },
        async markAsRead(this: any) {
            const ids = this.notificationsData.map((item: any) => item.id);
            this.readNotificationIDs = ids;
            localStorage.setItem('readNotificationIDs', JSON.stringify(ids));
        },
    },
});
